export default __webpack_public_path__ + "static/media/f25-starbull.dd6dce9e.png";